/**
 * @fileoverview Which failed tiles are uploads whose file never reached storage.
 *
 * Only those get the "Re-upload" treatment. An upload that arrived but failed
 * afterwards (completion or processing) keeps the regular failure UI and its
 * real error, since sending the same file again is not the fix.
 */

import type { Asset } from '@/types'

/** The file transfer to storage failed; the bytes never arrived. */
export const UPLOAD_INTERRUPTED_CODE = 'UPLOAD_INTERRUPTED'
export const UPLOAD_INTERRUPTED_MESSAGE = "This file didn't finish uploading."

/** The file arrived but registering it with the backend failed. */
export const UPLOAD_COMPLETE_FAILED_CODE = 'UPLOAD_COMPLETE_FAILED'
export const UPLOAD_COMPLETE_FAILED_MESSAGE = "This file uploaded but couldn't be processed. Try again in a moment."

export function isInterruptedUpload(asset: Pick<Asset, 'operation' | 'status' | 'error' | 'uri'>): boolean {
  if (asset.operation !== 'upload' || asset.status !== 'failed') return false
  if (asset.error) return asset.error.code === UPLOAD_INTERRUPTED_CODE
  // Tiles failed by reconciliation before failures carried a reason: no error
  // and no stored file means the transfer never finished.
  return !asset.uri
}
